import { Component } from '@angular/core';

@Component({
  selector: 'curbnturf-agritourism-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
})
export class AgritourismFooterComponent {}
